import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MitsHeaderComponent } from './mits-header.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [MitsHeaderComponent],
  entryComponents: [MitsHeaderComponent],
  exports: [MitsHeaderComponent],
  providers: [],
})
export class MitsHeaderModule {}
